import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

export const plannedItemNameCellStyleId = 'planned-item-name-cell-theme';

export const plannedItemNameCellBridgeStyles = {
  'planned-item-name-cell-renderer': {
    // Same role and same size as the shared item cell's location line: a muted second line.
    '--local-planned-item-name-location-text': tokens.color.text.tertiary,
    '--local-planned-item-name-location-font-size': tokens.font.size.textSm,
    // The gap between the name and its change pill, and the muted name of an excluded line.
    '--local-planned-item-name-pill-gap': tokens.spacing.sm,
    '--local-planned-item-name-excluded-text': tokens.color.text.tertiary,
  },
};
